module.exports = __webpack_public_path__ + "img/vps_d.0fe0e51.svg";